import { Api } from '@/api/api.client';
import type { Components } from '@/api/generated/api';

export async function readStudentImportFile(
  file: File,
  schoolClassId?: number,
): Promise<Components.Schemas.StudentImportRowDto[]> {
  const result = await Api.Routes.StudentImport.readFile({ schoolClassId }, { file });
  return result.data.students;
}

export async function readStudentImportText(
  text: string,
  schoolClassId?: number,
): Promise<Components.Schemas.StudentImportRowDto[]> {
  const result = await Api.Routes.StudentImport.readText({ schoolClassId }, { text });
  return result.data.students;
}

/** For each name, whether a student of the class or of the school has it already; without a class, of the school. */
export async function matchStudentImportNames(params: {
  schoolClassId?: number;
  students: Components.Schemas.StudentImportRowDto[];
}): Promise<Components.Schemas.StudentNameMatchDto[]> {
  const result = await Api.Routes.StudentImport.matchNames(null, params);
  return result.data.matches;
}
